import {
  locationsListRoute,
  tenantLocationsListRoute,
} from "./locations-list/index.js";
import {
  locationDetailsRoute,
  tenantLocationDetailsRoute,
} from "./location-details/index.js";
import {
  orderDetailsRoute,
  ordersRoute,
  tenantOrderDetailsRoute,
  tenantOrdersRoute,
} from "./orders-details/index.js";
import { imprintRoute } from "./imprint/index.js";
import { TRoute } from "./types.js";
import { tenantDetailsRoute } from "./tenant-details/index.js";
import {
  areaOverviewRoute,
  locationOverviewRoute,
  overviewRoute,
  tenantOverviewRoute,
} from "./doors-overview/index.js";
import { locationStatusRoute } from "./location-status/index.js";

const indexRoute: TRoute<Record<string, never>, Record<string, never>> = {
  path: "/",
  redirect: (params, initialTenant) =>
    initialTenant
      ? {
          to: `/tenants/${initialTenant}`,
          replace: true,
        }
      : null,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const routes: TRoute<any, any>[] = [
  locationsListRoute,
  tenantLocationsListRoute,
  tenantDetailsRoute,
  tenantLocationDetailsRoute,
  locationDetailsRoute,
  tenantOverviewRoute,
  locationOverviewRoute,
  areaOverviewRoute,
  overviewRoute,
  orderDetailsRoute,
  tenantOrderDetailsRoute,
  ordersRoute,
  tenantOrdersRoute,
  imprintRoute,
  indexRoute,
  locationStatusRoute,
];
